export default {
  BOOKING: 'booking',
  BOOKING_ARRIVAL: 'bookingArrival',
  ARRIVAL: 'arrival',
};



// WEBPACK FOOTER //
// ./src/variables/ski/school/sales-type-enums.js